import getUserConfiguration from '../actions/getUserConfiguration';

export default () => getUserConfiguration().UserOptions;
